module.exports = __webpack_public_path__ + "static/img/activity_three.c1ecc16a.jpg";